{
  "ask_more_storage": "Ask more storage",
  "for_more": "For more storage feel free to contact us at:"
}
